import { useEffect } from 'react';

import { selectEffectiveMaxCollateral, useTradingStore } from '../store';

/**
 * Reactive effect that clamps betAmount only when external constraints reduce
 * the maximum allowed value (e.g. balance drops or leverage max changes).
 *
 * Minimum validation is intentionally soft for freeform typing, so we do not
 * auto-bump values upward while the user edits the field.
 */
export function useBetClampEffect(): void {
    const betAmount = useTradingStore((s) => s.betAmount);
    const activePosition = useTradingStore((s) => s.activePosition);
    const effectiveMaxCollateral = useTradingStore(
        selectEffectiveMaxCollateral,
    );

    useEffect(() => {
        if (
            !activePosition &&
            effectiveMaxCollateral !== null &&
            betAmount > effectiveMaxCollateral
        ) {
            useTradingStore.getState().setBetAmount(effectiveMaxCollateral);
        }
    }, [activePosition, betAmount, effectiveMaxCollateral]);
}
